export const FIRELINE_MEDIC_BADGE = '/logos/line-medic-badge.webp?v=3';
